import React from 'react';
import { useLocation, useNavigate } from 'react-router';
import { Gutter, Suspense, TabsItem, Tabs, useApi } from '@axiom/ui';
import { isEnvoyAdmin, isSalesUser as isSalesUserCheck } from '@axiom/utils';

import { UserApi } from '../../api/user-api';

import { WorkspaceGrid } from './WorkspaceGrid';
import { WorkspaceBenchReminders } from './WorkspaceBenchReminders';
import { WorkspaceInterviews } from './WorkspaceInterviews';
import { TAB_NAME_PATH_MAP } from './workspace.const';
import { WorkspaceTalentFeedback } from './WorkspaceTalentFeedback';

const denyTabList = new Set(['bench-reminders']);

type TabType = keyof typeof TAB_NAME_PATH_MAP;

export const WorkspaceTabs = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [{ data: user }] = useApi(UserApi.readSessionUser());
  const isSalesUser = isSalesUserCheck(user) && !isEnvoyAdmin(user);

  const goToTab = (tabSlug: string) => {
    void navigate(`/workspace/${tabSlug}`);
  };

  const getStartTab = () => {
    for (const tab of Object.keys(TAB_NAME_PATH_MAP) as TabType[]) {
      if (
        !(isSalesUser && denyTabList.has(tab)) &&
        pathname.includes(`/${tab}`)
      ) {
        return TAB_NAME_PATH_MAP[tab];
      }
    }

    void navigate(`/workspace/${TAB_NAME_PATH_MAP.opportunities}`);
    return TAB_NAME_PATH_MAP.opportunities;
  };

  return (
    <Gutter top="16px" name="WORKSPACE_TABS">
      <Tabs name="tabs" startTab={getStartTab()} stretched>
        <TabsItem
          key="opportunities"
          name={TAB_NAME_PATH_MAP.opportunities}
          label="My Opportunities"
          onClick={() => {
            goToTab('opportunities');
          }}
        >
          <Suspense stretched>
            <WorkspaceGrid user={user} />
          </Suspense>
        </TabsItem>

        {isSalesUser ? null : (
          <TabsItem
            key="bench-reminders"
            name={TAB_NAME_PATH_MAP['bench-reminders']}
            label="Bench Reminders"
            onClick={() => {
              goToTab('bench-reminders');
            }}
          >
            <Suspense stretched>
              <WorkspaceBenchReminders user={user} />
            </Suspense>
          </TabsItem>
        )}

        <TabsItem
          key="talent-feedback"
          name={TAB_NAME_PATH_MAP['talent-feedback']}
          label="Talent Feedback"
          onClick={() => {
            goToTab('talent-feedback');
          }}
        >
          <Suspense stretched>
            <WorkspaceTalentFeedback
              userId={user.id}
              name="TALENT_FEEDBACK_GRID_LAYOUT"
            />
          </Suspense>
        </TabsItem>

        <TabsItem
          key="interviews"
          name={TAB_NAME_PATH_MAP.interviews}
          label="Interviews"
          onClick={() => {
            goToTab('interviews');
          }}
        >
          <Suspense stretched>
            <WorkspaceInterviews />
          </Suspense>
        </TabsItem>
      </Tabs>
    </Gutter>
  );
};
